import { FORMAT_PERIOD_DATE_COLUMN } from '../../../components/table/TableKeyValuePureMarkup/TableKeyValuePureMarkup';
import {
  FORMAT_COMMON_COLUMN,
  FORMAT_CURRENCY_AUTO_COMMA_COLUMN,
  FORMAT_DATE_COLUMN,
} from '../../../components/table-row/TableRowPureMarkup/TableRowPureMarkup';

import {
  primaryTableDataGreyBackgroundNgreyTopBottomBorder,
  secondarySubtitleCalculationNumberParagraph,
} from './additional-styles';

// column sales payment list that handling table head with translation
export const columnsTableHeaderSalesPayment = (t) => {
  return [
    {
      name: 'transaction_date',
      name_input: 'from_date',
      label: t('dashboard.sales.sales-payment.table.header-column.transaction-date'),
      placeholder: t('dashboard.sales.sales-payment.input.search-transaction-date.placeholder'),
      width: 200,
    },
    {
      name: 'sales_payment_no',
      name_input: 'sales_payment_no',
      label: t('dashboard.sales.sales-payment.table.header-column.transaction-no'),
      placeholder: t('dashboard.sales.sales-payment.input.search-transaction-no.placeholder'),
      width: 200,
    },
    {
      name: 'customer_name',
      name_input: 'customer_name',
      label: t('dashboard.sales.sales-payment.table.header-column.customer'),
      placeholder: t('dashboard.sales.sales-payment.input.search-customer.placeholder'),
      width: 400,
      align: 'left',
    },
    {
      name: 'amount',
      label: t('dashboard.sales.sales-payment.table.header-column.nominal'),
      align: 'right',
      width: 150,
    },
  ];
};

export const columnsSearchWithDate = ['from_date', 'to_date'];

// column that representation for calculation
export const calculationColumns = ['amount'];

export const columnsTableFooterInvoiceSalesPaymentList = (t) => {
  return [
    [
      {
        isEmptyTableData: true,
        colSpan: 3,
      },
      {
        isLabel: true,
        label: t('typography.total'),
        typographyStyle: secondarySubtitleCalculationNumberParagraph,
        tableDataStyle: primaryTableDataGreyBackgroundNgreyTopBottomBorder,
      },
      {
        isValue: true,
        valueKeyName: 'amount',
        tableDataStyle: primaryTableDataGreyBackgroundNgreyTopBottomBorder,
        substituteNotExistValue: 0,
        typographyStyle: secondarySubtitleCalculationNumberParagraph,
      },
    ],
  ];
};

// print pdf sales payment
export const columnsTableHeaderSalesPaymentPDFprint = (t) => {
  return [
    {
      name: 'transaction_date',
      label: t('dashboard.sales.sales-payment.table.header-column.transaction-date'),
      style: {
        position: 'unset',
        width: 200,
      },
      formatData: FORMAT_DATE_COLUMN,
    },
    {
      name: 'sales_payment_no',
      label: t('dashboard.sales.sales-payment.table.header-column.transaction-no'),
      style: {
        position: 'unset',
        width: 200,
      },
      formatData: FORMAT_COMMON_COLUMN,
    },
    {
      name: 'customer_name',
      label: t('dashboard.sales.sales-payment.table.header-column.customer'),
      style: {
        position: 'unset',
        width: 400,
      },
      align: 'left',
      formatData: FORMAT_COMMON_COLUMN,
    },
    {
      name: 'amount',
      label: t('dashboard.sales.sales-payment.table.header-column.nominal'),
      style: {
        position: 'unset',
        width: 150,
      },
      formatData: FORMAT_CURRENCY_AUTO_COMMA_COLUMN,
      isUseZeroNumberWhenNull: true,
      align: 'right',
    },
  ];
};

// columns table sales payment print
export const columnsTableKeyValuePrintIndexSalesPayment = [
  {
    header: 'dashboard.sales.sales-payment.table.header-column.transaction-date',
    valueKeyName: 'search_from_date',
    valueKeyNameSecondary: 'search_to_date',
    formatValue: FORMAT_PERIOD_DATE_COLUMN,
    showOnlyWhenExistedValue: true,
  },
  {
    header: 'dashboard.sales.sales-payment.table.header-column.transaction-no',
    valueKeyName: 'search_sales_payment_no',
    showOnlyWhenExistedValue: true,
  },
  {
    header: 'dashboard.sales.sales-payment.table.header-column.customer',
    valueKeyName: 'search_customer_name',
    showOnlyWhenExistedValue: true,
  },
];
